import { captureException, close, getClient, getGlobalScope, init, replayIntegration, setContext } from '@sentry/browser';
import { getLogger } from '../otel';
import { defaultSessionOptions, unmaskedSessionOptions, } from './sentry.util';
let isInitialized = false;
let logger = console;
let replay = null;
export const initReplayService = async ({ dsn, releaseVersion, userId, clusterId, clusterName, userLocale, orgId, isEmbedded, env, }) => {
    try {
        await close();
        logger = getLogger('session-replay');
        init({
            dsn,
            release: releaseVersion,
            environment: env,
        });
        const globalScope = getGlobalScope();
        globalScope.setUser({
            id: userId,
        });
        globalScope.setTag('clusterId', clusterId);
        globalScope.setTag('clusterName', clusterName);
        globalScope.setTag('userLocale', userLocale);
        globalScope.setTag('orgId', orgId);
        globalScope.setTag('isEmbedded', isEmbedded);
        isInitialized = true;
    }
    catch (e) {
        logger.error('Failed to initialize Sentry');
    }
};
export const startAnonymizedReplay = async (isUnmaskedReplay) => {
    if (!isInitialized) {
        logger.error('Sentry not initialized');
        return;
    }
    if (replay) {
        replay._isInitialized = false;
        await replay.stop();
    }
    if (isUnmaskedReplay) {
        replay = replayIntegration({
            ...defaultSessionOptions,
            ...unmaskedSessionOptions,
            beforeAddRecordingEvent: (event) => {
                return event;
            },
        });
    }
    else {
        replay = replayIntegration({
            ...defaultSessionOptions,
        });
        const sentryClient = getClient();
        sentryClient.addIntegration(replay);
        replay.start();
    }
};
export const trackException = (error, context) => {
    const isTestEnv = process.env.NODE_ENV === 'test';
    if (isTestEnv) {
        return;
    }
    if (!isInitialized) {
        console.error('Sentry not initialized');
        return;
    }
    if (context) {
        setContext('Current context', context);
    }
    captureException(error);
};
export const startFullReplay = async (isUnmaskedReplay) => {
    if (!isInitialized) {
        logger.error('Sentry not initialized');
        return Promise.reject();
    }
    if (replay) {
        replay._isInitialized = false;
        await replay.stop();
    }
    if (isUnmaskedReplay) {
        replay = replayIntegration({
            ...defaultSessionOptions,
            ...unmaskedSessionOptions,
            beforeAddRecordingEvent: (event) => {
                return event;
            }
        });
    }
    else {
        replay = replayIntegration({
            ...defaultSessionOptions,
        });
    }
    const sentryClient = getClient();
    sentryClient.addIntegration(replay);
    replay.start();
    return replay.getReplayId();
};
export const stopReplay = async () => {
    await replay?.stop();
};
//# sourceMappingURL=sentry.js.map